export const SCOIN_OR_DAY = 1;
export const SCOIN_AND_DAY = 2;
export const SCOIN = 3;
export const DAY = 4;
export const NONE = 5;
export const FREE = 6;


// WEBPACK FOOTER //
// ./src/constants/TypesMediaPurchase.js